import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./loading-medium.svg?react";

export const LoadingMediumIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
